import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Loader2, ChevronLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Direct login without password
    setTimeout(() => {
      localStorage.setItem('sbs_admin', 'true');
      localStorage.setItem('admin_password', 'skillbharat2026');
      navigate('/admin/dashboard');
    }, 500);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6 relative noise-bg">
      {/* Back Button */}
      <Button
        data-testid="back-button"
        variant="ghost"
        onClick={() => navigate('/')}
        className="absolute top-8 left-8 text-muted-foreground hover:text-foreground"
      >
        <ChevronLeft className="w-4 h-4 mr-2" />
        <span className="text-xs uppercase tracking-widest font-bold">Back</span>
      </Button>
      
      <Card className="w-full max-w-sm bg-card/50 backdrop-blur-sm border-border animate-fade-in">
        <CardContent className="p-10">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="p-4 bg-primary/10 rounded-sm">
              <ShieldCheck className="w-10 h-10 text-primary" />
            </div>
          </div>
          
          {/* Title */}
          <h1 className="text-2xl font-bold text-center mb-2 tracking-tight text-[#F2F0E9]">
            Admin Access
          </h1>
          <p className="text-center text-muted-foreground text-sm mb-8">
            Click below to access the dashboard
          </p>
          
          {/* Login Button */}
          <Button
            data-testid="login-button"
            onClick={handleLogin}
            disabled={loading}
            className="w-full py-5 bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-bold rounded-sm"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              'Enter Admin Panel'
            )}
          </Button>
          
          {/* Hint */}
          <p className="text-center text-xs text-muted-foreground mt-6">
            Authorized personnel only
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
